// extracted by mini-css-extract-plugin
export default {"button":"Iumy0cPhs6OGzTOuryjFgrMpUfERRgUl","buttonAnimation":"jr7fF8jBjhb4L_lSfWZLlg9dgSxYrXAG"};